import DetailedFullMap from './DetailedFullMap';

import type { PoiDataState } from '@hotels-hotel-detail/data-access/types';
import type { HotelContent } from '@shared/types/hotel-content';

import { withPoiDataState } from '@hotels-hotel-detail/data-access/contexts/PoiDataContext';
import {
  THING_TO_DO,
  TRANSPORT,
} from '@hotels-hotel-detail/utils/location-constants';
import withScrimmedPortal from '@shared/ui/common/withScrimmedPortal';

const FullScreenDetailedFullMap = withScrimmedPortal(DetailedFullMap);

type Props = {
  poiDataState: PoiDataState;
  uBFFHotel: HotelContent;
  onClose: () => void;
};

const DetailedFullMapContainer = ({
  onClose,
  poiDataState: {
    airport = [],
    nearbyPoi = [],
    onPoiMarkerClick,
    onTabClick,
    selectedEntityId,
    selectedTab,
    transportWithoutAirport = [],
  },
  uBFFHotel,
}: Props) => {
  const categories: string[] = [];
  if (nearbyPoi.length > 0) {
    categories.push(THING_TO_DO);
  }
  if (airport.concat(transportWithoutAirport).length > 0) {
    categories.push(TRANSPORT);
  }

  let defaultTab;
  if (selectedTab && categories.indexOf(selectedTab) >= 0) {
    defaultTab = selectedTab;
  } else if (categories.length > 0) {
    [defaultTab] = categories;
  } else {
    defaultTab = THING_TO_DO;
  }

  return (
    <FullScreenDetailedFullMap
      isOpen
      onTabClick={onTabClick}
      onPoiMarkerClick={onPoiMarkerClick}
      selectedEntityId={selectedEntityId}
      selectedTab={defaultTab}
      categories={categories}
      uBFFHotel={uBFFHotel}
      nearbyPoi={nearbyPoi}
      airport={airport}
      transportWithoutAirport={transportWithoutAirport}
      onClose={onClose}
    />
  );
};

export default withPoiDataState(DetailedFullMapContainer);
